




















































































































import Vue from 'vue'
import actions from '@/actions'
import api from '@/api'
import store from '@/store'
import { ImageFile, Portfolio } from '../types'

export default Vue.extend({
  name: 'AdminPortfolio',

  data: () => ({
    portfolio: { metadata: { photos: {}, colleague: {}, builder: {} } } as Portfolio,
    store,
    unsavedImages: [] as Array<string>,
  }),

  computed: {
    hasUploadedFiles(): boolean {
      if (!this.portfolio) return false
      if (!this.portfolio.images) return false

      return this.portfolio.images.length > 0
    },

    photos(): Array<ImageFile> {
      if (!this.portfolio) return []
      if (!this.portfolio.images) return []

      return this.portfolio.images
    },
  },

  methods: {
    confirmDeleteImage(image: ImageFile) {
      // eslint-disable-next-line no-restricted-globals
      if (confirm(`Are you sure you want to delete image '${image.filename}'?`)) { // eslint-disable-line no-alert
        this.deleteImage(image)
      }
    },

    async deleteImage(image: ImageFile): Promise<void> {
      if (!this.portfolio.id) return
      if (this.store.state.isBusy) return

      this.store.setIsBusy(true)
      await api.deletePortfolioImage(this.portfolio.id, image.remoteFilename)
      this.portfolio.images = (this.portfolio.images || [])
        .filter(i => i.filename !== image.filename)
      this.store.setIsBusy(false)
    },

    goBack() {
      this.$router.push({ name: 'AdminPortfolioList' })
    },

    handleClickSelectedImage(event: Event) {
      // TODO remove image from local state
      console.log(event.target)
    },

    handleFileChange() {
      const input = document.querySelector('#photos') as HTMLInputElement

      if (input && input.files) {
        this.unsavedImages = Array.from(input.files).map(f => URL.createObjectURL(f))
      }
    },

    isFeature(image: ImageFile): boolean {
      return (this.portfolio.images || [])
        .filter(i => i.featured)
        .find(i => i.filename === image.filename) != null
    },

    setFeature(image: ImageFile): void {
      this.portfolio.images = (this.portfolio.images || [])
        .slice()
        .map(i => {
          i.featured = i.filename === image.filename // eslint-disable-line no-param-reassign
          return i
        })
    },

    srcFor(image: ImageFile): string {
      if (this.portfolio.id) {
        return `${store.state.apiBaseUrl}/img/portfolio/${this.portfolio.id}/${image.remoteFilename}`
      }

      return ''
    },

    async submit(e: Event) {
      e.preventDefault()
      if (this.store.state.isBusy) return

      this.store.setIsBusy(true)
      const input = document.querySelector('#photos') as HTMLInputElement
      const formData = new FormData()
      if (input && input.files) {
        Array.from(input.files).forEach(file => {
          formData.append('photos', file)
        })
      }

      try {
        if (this.portfolio.id) {
          await actions.updatePortfolio(this.portfolio.id, this.portfolio, formData)
        } else {
          await actions.createPortfolio(this.portfolio, formData)
        }
        this.$router.push({ name: 'AdminPortfolioList' })
      } catch (err) {
        this.store.setErrorMessage('Could not save portfolio')
      } finally {
        this.store.setIsBusy(false)
      }
    },
  },

  async mounted() {
    if (this.$route.params.id !== 'new') {
      this.portfolio = await api.getPortfolio(this.$route.params.id)
    }
  },
})
